<template>
  <v-container grid-list-xl fluid>
    
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout row wrap>
      <v-dialog v-model="dialogComentario" max-width="900" style="z-index:999999" @input="v => v || cancelarComentario()">
      <v-form v-model="valid" ref="formComentario">       
      <v-card>
        <v-toolbar dark color="green" dense flat>
          <v-toolbar-title class="white--text">Agregar Mensaje Gestión</v-toolbar-title>
          </v-toolbar>
        <v-card-text>
          <v-flex sm3>
            <v-select
            :items="tiposComentario"
            v-model="selectComentario"
            label="Seleccione tipo mensaje"
            item-text="name"
            item-value="name"             
            max-height="auto"
            autocomplete
                    return-object                    
          >
              <template slot="selection" slot-scope="data">                          
                 <v-btn             
                    :color="data.item.icon === 'info' ? 'blue' : 'orange'"
                    class="ma-2 white--text" 
                    x-small         
                  >              
              <v-icon left dark>{{ data.item.icon }}</v-icon>
              {{ data.item.name }}
            </v-btn>
            </template>
            <template slot="item" slot-scope="data">                          
                 <v-btn             
                    :color="data.item.icon === 'info' ? 'blue' : 'orange'"
                    class="ma-2 white--text" 
                    x-small         
                  >              
              <v-icon left dark>{{ data.item.icon }}</v-icon>
              {{ data.item.name }}
            </v-btn>
            </template>
          </v-select>
          </v-flex>
          <v-flex sm12>
                <v-textarea
                label="Comentario"
                v-model="tempComentario"                 
                auto-grow
                 :rules="[v => !!v || 'Comentario es obligatorio']" 
              ></v-textarea>
              </v-flex></v-card-text>
        <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat="flat"  @click="guardarComentario()" :loading="loadingComentario"><v-icon>save</v-icon> Guardar</v-btn>
        <v-btn color="grey" flat="flat" @click="cancelarComentario()" :loading="loadingComentario"><v-icon>cancel</v-icon> Cancelar</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
      <v-dialog v-model="dialogDetalleCorrelativo" persistent max-width="1100px">
        <v-card>           
          <v-card-title>
            <span class="title">Detalle Línea {{ detalleItem.correlativo }} OC</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Correlativo"
                    v-model="detalleItem.correlativo"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md9>&nbsp;</v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Código Categoria"
                    v-model="detalleItem.codigoCategoria"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md9>
                  <v-text-field label="Categoria" v-model="detalleItem.categoria" :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Código Producto"
                    v-model="detalleItem.codigoProducto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md9>
                  <v-text-field
                    label="Descripción Producto"
                    v-model="detalleItem.producto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    label="Especificación Comprador"
                    v-model="detalleItem.especificacionComprador"
                    no-resize
                    :readonly="true"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    label="Especificación Proveedor"
                    v-model="detalleItem.especificacionProveedor"
                    no-resize
                    :readonly="true"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Moneda" v-model="detalleItem.moneda" :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Cantidad"
                    type="number"
                    v-model="detalleItem.cantidad"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-currency-field
                    label="Precio Unitario"
                    :readonly="true"
                    prefix="$"
                    v-model="detalleItem.precioNeto"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>&nbsp;</v-flex>
                <v-flex xs12 sm6 md3>
                  <v-currency-field
                    label="Total Cargos"
                    :readonly="true"
                    prefix="$"
                    v-model="detalleItem.totalCargos"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-currency-field
                    label="Total Descuentos"
                    :readonly="true"
                    prefix="$"
                    v-model="detalleItem.totalDescuentos"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-currency-field
                    label="Total Impuestos"
                    :readonly="true"
                    prefix="$"
                    v-model="detalleItem.totalImpuestos"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-currency-field
                    label="Total"
                    :readonly="true"
                    prefix="$"
                    v-model="detalleItem.total"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <span class="title">Información Validación Línea</span>
                    </v-card-title>
                     <v-card-text>                    
                      <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs2>
                              <v-checkbox
                              v-model="detalleItem.validarLineaIntegracion"                              
                              label="Detalle OK?"
                              :readonly="isReadOnlyDetalle()"       
                            ></v-checkbox>
                           </v-flex>
                           <v-flex xs10>
                              <v-textarea
                              label="Observaciones"
                              v-model="detalleItem.observacionesIntegracion"
                              auto-grow       
                              :readonly="isReadOnlyDetalle()"                       
                            ></v-textarea>                             
                           </v-flex>
                            <v-flex xs2 v-if="detalleItem.glosaUsuarioValidador">
                             &nbsp;
                           </v-flex>
                            <v-flex xs10 v-if="detalleItem.glosaUsuarioValidador">
                              <v-text-field 
                              label="Validado por"
                              v-model="detalleItem.glosaUsuarioValidador"
                              :readonly="true"                              
                            ></v-text-field>
                           </v-flex>
                          
                        </v-layout>
                      </v-container>
                     </v-card-text>
                  </v-card>
                </v-flex>
                <!-- INFO INTEGRACION NO VALIDA GASCO
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <span class="title">Información Integración</span>
                    </v-card-title>
                    <v-card-text>                    
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs4>
                            <v-combobox
                              v-model="detalleItem.codigoComboIntegracion"
                              :items="productosBusqueda"
                              :loading="isLoading"
                              :search-input.sync="searchProductos"
                              hide-no-data
                              hide-selected
                              item-text="codigoDescripcion"
                              item-value="codigo"
                              label="Código Producto *"
                              placeholder="Código Producto *"
                              prepend-icon="search"
                              :no-filter="true"
                              return-object
                              @change="setProducto"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs2>
                            <v-currency-field
                              label="Factor Empaque"
                              v-model="detalleItem.cantidadFactor"
                              :readonly="AplicaFactor"
                              @change="setCalculateTotales"
                              ref="factorEmpaque"
                            />
                            <loader
                              :value="loadingFactores"
                              message="Recalculando factores"
                              progressColor="blue"
                            ></loader>
                             <loader
                              :value="loadingDetalle"
                              message="Actualizando información detalle"
                              progressColor="blue"
                            ></loader>
                          </v-flex>
                          <v-flex xs2>
                            <v-checkbox
                              v-model="detalleItem.aplicaFactor"
                              @change="setCalculateTotales"
                              label="Aplica Factor?"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              label="Unidad Medida"
                              v-model="detalleItem.unidadMedidaIntegracion"
                              :readonly="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              label="Cantidad Integracion"
                              type="number"
                              v-model="detalleItem.cantidadIntegracion"
                              :readonly="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              label="Nro. Contrato"
                              v-model="detalleItem.nroContratoIntegracion"
                              :readonly="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              label="Posición Contrato"
                              v-model="detalleItem.posicionContratoIntegracion"
                              :readonly="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              label="Tipo Precio"
                              v-model="detalleItem.tipoContratoIntegracion"
                              :readonly="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-currency-field
                              label="Precio Unitario"
                              v-model="detalleItem.precioIntegracion"
                              :readonly="true"
                              prefix="$"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-currency-field
                              label="Total Cargos"
                              :readonly="true"
                              prefix="$"
                              v-model="detalleItem.totalCargos"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-currency-field
                              label="Total Descuentos"
                              :readonly="true"
                              prefix="$"
                              v-model="detalleItem.totalDescuentos"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-currency-field
                              label="Total Impuestos"
                              :readonly="true"
                              prefix="$"
                              v-model="detalleItem.totalImpuestos"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-currency-field
                              label="Total Unitario"
                              :readonly="true"
                              prefix="$"
                              v-model="detalleItem.totalUnitario"
                            />
                          </v-flex>
                          <v-flex xs9>&nbsp;</v-flex>
                          <v-flex xs3>
                            <v-currency-field
                              label="Total Integración"
                              :readonly="true"
                              prefix="$"
                              v-model="detalleItem.totalIntegracion"
                            />
                          </v-flex>                        
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex> FIN INFO INTEGRACION-->
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- solo gasco
            <v-btn color="success" @click="saveDetalleItem()" dark>
              <v-icon class="mr-1">done_all</v-icon>Guardar
            </v-btn>
            <v-btn color="orange" @click="cancelDetalleItem()" dark>
              <v-icon class="mr-1">history</v-icon>Cancelar
            </v-btn>-->
             <v-btn color="success" @click="saveDetalleItem()" dark :loading="loadingDetalle" v-if="!isReadOnlyDetalle()">
              <v-icon class="mr-1">save</v-icon>Guardar
            </v-btn>
            <v-btn color="grey" @click="cleanDetalleOC" dark :loading="loadingDetalle">
              <v-icon class="mr-1">cancel</v-icon>Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogHistorial" persistent max-width="1100px">
        <v-card v-if="!loadingHistorial">         
          <v-card-title>
            <span class="title">Historial de Gestión</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex sm12>
         <v-card>
    <!--<v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Historial Gestión</h4></v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>-->
         <v-card-text class="pa-0">
          <v-list two-line class="pa-0 comentarios comentarioStatusLineas" >
            <template v-for="(item, index) in detalleHistorial">              
              <v-divider ></v-divider>
              <v-list-tile avatar   @click="handleClick(item)">                  
                   <v-list-tile-avatar  :color="calculaStatus(item.accionInicio)">
                  <v-icon dark>{{ item.icon }} </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="comentarioStatus">   

                     
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn             
                            :color="calculaStatus(item.accionInicio)"
                              class="white--text" 
                            small   v-on="on"      
                            >   
                          {{ item.accionInicio }} 
                          </v-btn>
                          <span v-on="on"> {{ item.observacion }}    </span>
                    </template>
                    <span> {{ item.accionInicio }} - {{ item.observacion }}    </span> <br/>
                   <span class='font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioNombre }}</span> &nbsp;
                       <span class="font-italic"><b>Inicio </b> {{ item.fechaAccionInicio }} </span> &mdash;
                       <span class='font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioCierreNombre }}</span> &nbsp;
                        <span class="font-italic"><b>Fin :</b> {{ item.fechaAccionCierre }} </span>
                  </v-tooltip>    

                    
                  </v-list-tile-title>
                  <v-list-tile-sub-title>

                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        
                                            
                                             <span  v-on="on" class='text--primary font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioNombre }}</span> &nbsp;
                                            <span v-on="on" class="font-italic">Inicio: {{ item.fechaAccionInicio }} </span> 
                                            
                                      </template>
                                      <span> {{ item.accionInicio }} - {{ item.observacion }}    </span> <br/>
                                    <span class='font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioNombre  }}</span> &nbsp;
                                        <span class="font-italic"><b>Inicio </b> {{ item.fechaAccionInicio }} </span>                                        
                                    </v-tooltip>    

                      
                  </v-list-tile-sub-title>
                   <v-list-tile-sub-title>

                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">  
                                            <span v-on="on" class='text--primary font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioCierreNombre }}</span> &nbsp;
                                              <span v-on="on" class="font-italic">Fin :{{ item.fechaAccionCierre }} </span>
                                      </template>
                                      <span> {{ item.accionInicio }} - {{ item.observacion }}    </span> <br/>                                    
                                        <span class='font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioCierreNombre }}</span> &nbsp;
                                          <span class="font-italic"><b>Fin :</b> {{ item.fechaAccionCierre }} </span>
                                    </v-tooltip>    

                      
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <v-divider></v-divider>
          <!--<v-btn block flat class="ma-0" v-if="items.length > 3">Ver todos</v-btn>-->
          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      </v-flex>  
                  
              </v-layout>
            </v-container>           
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" @click="cleanHistorial" dark>
              <v-icon class="mr-1">cancel</v-icon>Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDetalleNotaVenta" persistent max-width="1100px">
        <v-card>         
          <v-card-title>
            <span class="title">Detalle nota de venta</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                    <loader
                              :value="loadingNotaVenta"
                              message="Actualizando información integración"
                              progressColor="blue"
                            ></loader>
                  <v-text-field
                    label="Nro de Documento"
                    v-model="integracion.nroDocumentoIntegracion"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menuFechaVencimientoIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Vencimiento"
                      prepend-icon="event"
                      v-model="dateFormatedBusquedaInicio"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaVencimientoIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-select
                    :items="['No aplica','Pesos', 'Porcentaje']"
                    label="Tipo Descuento"
                    v-model="integracion.tipoDescuentoIntegracion"
                  ></v-select>
                 
                </v-flex>
                <v-flex xs12 sm6 md3>
                   <v-currency-field v-if="integracion.tipoDescuentoIntegracion == 'Porcentaje'"
                              label="% Descuento"
                              v-model="integracion.descuentoGralIntegracion"
                              
                              min=0 max=100
                            />
                    <v-currency-field v-if="integracion.tipoDescuentoIntegracion == 'Pesos'"
                              label="Descuento en Pesos"
                              v-model="integracion.descuentoGralIntegracion"
                              decimalLength=0
                              min=0
                            /> 
                            &nbsp;
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Código Vendedor"
                    v-model="integracion.codigoVendedorIntegracion"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field label="Glosa Pago" v-model="integracion.glosaPagoIntegracion"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Día Vencimiento"
                    v-model="integracion.diaVencimientoIntegracion"
                    type="number" min=0
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-select
                    :items="['No aplica','Tipo 1', 'Tipo 2']"
                    label="Tipo Venta"
                    v-model="integracion.tipoVentaIntegracion"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menufechaEntregaIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Entrega"
                      prepend-icon="event"
                      v-model="dateFormatedfechaEntregaIntegracion"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaEntregaIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6>&nbsp;</v-flex>
                <!-- guia -->

                <v-flex xs12 sm6 md3>
                  <v-text-field label="HES" v-model="integracion.hesreferenciaIntegracion"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menuFechaHESIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha HES"
                      prepend-icon="event"
                      v-model="dateFormatedfechaHESIntegracion"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.hesfechaIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Nro Guía Despacho"
                    v-model="integracion.guiaDespachoIntegracion"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menufechaGuiaIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Guía Despacho"
                      prepend-icon="event"
                      v-model="dateFormatedfechaGuiaIntegracion"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaGuiaIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>               
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Nro Contrato" v-model="integracion.nroContratoIntegracion"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menuFechaContratoIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Contrato"
                      prepend-icon="event"
                      v-model="dateFormatedfechaContratoIntegracion"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaContratoIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-text-field label="Nro Pedido Ref." v-model="integracion.nroPedidoReferencia"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menuFechaPedidoReferencia"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Pedido Ref."
                      prepend-icon="event"
                      v-model="dateFormatedfechaPedidoReferencia"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaPedidoReferencia"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>              
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Nro Cuenta Venta"
                    v-model="integracion.cuentaVentaIntegracion"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-text-field label="Nro Pedido" v-model="integracion.nroPedidoIntegracion"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="integracion.menuFechaPedidoIntegracion"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Pedido"
                      prepend-icon="event"
                      v-model="dateFormatedfechaPedidoIntegracion"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="integracion.fechaPedidoIntegracion"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

               

                <!-- obs-->
                <v-flex xs6>
                  <v-textarea
                    label="Observaciones"
                    v-model="integracion.observacionesFavintegracion"
                    no-resize
                  ></v-textarea>
                </v-flex>

                <v-flex xs6>
                  <v-textarea
                    label="Observaciones Guía Despacho"
                    v-model="integracion.observacionesGuiaIntegracion"
                    no-resize
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*campos obligatorios</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="success" @click="saveDetalleNotaVenta()" dark>
              <v-icon class="mr-1">done_all</v-icon>Guardar
            </v-btn>
            <v-btn color="orange" @click="cancelDetalleNotaVenta()" dark>
              <v-icon class="mr-1">history</v-icon>Cancelar
            </v-btn>
            <v-btn color="grey" @click="cleanDetalleNotaVenta" dark>
              <v-icon class="mr-1">cancel</v-icon>Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex sm12 v-if="!loading">
        <v-card>
         <!-- <v-toolbar color="transparent" flat dense card>
            <v-toolbar-title>
              <h4>Orden de Compra {{ ordencompra.codigo }} - Información Comprador</h4>
              
                <v-btn
              color="green"
              small
              dark
              @click="exportarOC(ordencompra.linkPDF)"
              slot="activator"
            >
              <v-icon>zoom_in</v-icon>Descargar PDF OC
            </v-btn>
            </v-toolbar-title>
            <v-spacer></v-spacer>
           
          </v-toolbar>-->
            <v-card-title class="pb-1 pt-1">
              <span class="title ml-1">Orden de Compra {{ ordencompra.codigo }} - Información Comprador</span>
              <v-spacer></v-spacer>
               <v-btn
              :color="setColorEstado(this.ordencompra.estado)"
              small
              dark
           
              slot="activator"
            >
              <v-icon>info</v-icon>Estado Mercado Público : {{ ordencompra.estado }}
            </v-btn>
                 <v-btn
              color="green"
              small
              dark
              @click="exportarOC(ordencompra.linkPDF)"
              slot="activator"
            >
              <v-icon>zoom_in</v-icon>Descargar PDF OC
            </v-btn>
            </v-card-title>
          <v-divider></v-divider>
          <v-card-title v-if="this.ordencompra.clienteEditable === true">
            <v-spacer></v-spacer>
           <!-- BTN NOTA VENTA SOLO GASCO 
             <v-btn
                           small dark
                            :color="setNotaVentaColorStatus(this.ordencompra.hasInfoIntegracion)"
                             :disabled="checkSaveNotaVentas()" 
                             @click="updateEstadoIntegracion()"
                          >
                            <v-icon v-if="checkSaveNotaVentas()" class="mr-1">done</v-icon>
                            <v-icon v-else class="mr-1">save</v-icon>
                            Confirmar datos nota de venta
                          </v-btn> 
           
           -->
           <v-btn
                           small dark
                            :color="setNotaVentaColorStatus(this.ordencompra.hasInfoIntegracion)"
                             v-if="checkSaveNotaVentas()"
                             
                          >
                            <v-icon v-if="checkSaveNotaVentas()" class="mr-1">done</v-icon>
                            <v-icon v-else class="mr-1">save</v-icon>
                            Datos confirmados
                          </v-btn> 
                           <v-btn
                           small dark
                            :color="setNotaVentaColorStatus(this.ordencompra.hasInfoIntegracion)"
                             v-else
                             @click="updateEstadoIntegracion()"
                          >
                            <v-icon v-if="checkSaveNotaVentas()" class="mr-1">done</v-icon>
                            <v-icon v-else class="mr-1">save</v-icon>
                            Confirmar datos órden de compra
                          </v-btn> 
  <v-btn
                            :color="calculaStatus(ordencompra.estadoGestion)"
                            class="white--text"
                            small
                           @click="updateEstadoAceptacion()"
                          ><v-icon class="mr-1">info</v-icon>{{ ordencompra.estadoGestion }}</v-btn>
            <!-- DETALLE VENTA SOLO GASCO              
            <v-btn :color="setNotaVentaColorStatus(this.ordencompra.hasInfoIntegracion)" small dark @click="modalDetalleVenta()" slot="activator">
              <v-icon>assignment_turned_in</v-icon>Detalle Nota Venta
            </v-btn> -->
              <v-btn
              color="green"
              small
              dark
              @click="verDetalleHistorial(ordencompra.codigo)"
              slot="activator"
            >
              <v-icon>history</v-icon>Historial de Gestión
            </v-btn>           
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    label="Rut"
                    v-model="ordencompra.comprador.rutUnidad"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Demandante"
                    v-model="ordencompra.comprador.nombreOrganismo"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field
                    label="Dirección"
                    v-model="ordencompra.comprador.direccionUnidadCompleta"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Unidad de Compra"
                    v-model="ordencompra.comprador.nombreUnidad"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field
                    label="Telefono"
                    v-model="ordencompra.comprador.fonoContacto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Fecha Envío OC"
                    v-model="ordencompra.fechas.fechaEnvioFormat"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Fax"
                    v-model="ordencompra.comprador.fonoContacto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Estado" v-model="ordencompra.estado" :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="ordencompra.codigoLicitacion !== ''">
                  <v-btn
                    color="green"
                    small
                    dark
                    @click="irLicitacion(ordencompra.codigoLicitacion)"
                    slot="activator"
                  >
                    <v-icon>zoom_in</v-icon>
                    Licitacion: {{ ordencompra.codigoLicitacion }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm12 v-if="!loading">
        <v-card>
          <v-toolbar color="transparent" flat dense card>
            <v-toolbar-title>
              <h4>Orden de Compra {{ ordencompra.codigo }} - Información Proveedor</h4>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    label="Nombre Proveedor"
                    v-model="ordencompra.proveedor.nombre"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Nombre Contacto"
                    v-model="ordencompra.proveedor.nombreContacto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Dirección"
                    v-model="ordencompra.proveedor.direccionCompleta"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Fono Contacto"
                    v-model="ordencompra.proveedor.fonoContacto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Rut"
                    v-model="ordencompra.proveedor.rutSucursal"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Nombre Órden Compra"
                    v-model="ordencompra.nombre"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Fecha Entrega Productos"
                    v-model="ordencompra.fechas.fechaAceptacionFormat"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Dirección Despacho"
                    v-model="ordencompra.comprador.direccionUnidadCompleta"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Dirección De Envío Factura"
                    v-model="ordencompra.comprador.direccionUnidadCompleta"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Método Despacho"
                    v-model="ordencompra.glosaDespacho"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Forma Pago"
                    v-model="ordencompra.glosaFormaPago"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Contacto OC"
                    v-model="ordencompra.comprador.contactoOCCompleto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Email Envío Factura"
                    v-model="ordencompra.comprador.mailContacto"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Fuente Financiamiento"
                    v-model="ordencompra.financiamiento"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Observaciones"
                    v-model="ordencompra.descripcion"
                    auto-grow
                    :readonly="true"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm6 v-if="!loading">
        <v-card>
          <v-toolbar color="transparent" flat dense card>
            <v-toolbar-title>
              <h4>
                Orden de Compra {{ ordencompra.codigo }} - Información Totales
              </h4>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs4>
                 
                   <v-currency-field v-if="ordencompra.tipoMoneda == 'CLP'"
                              label="Total Descuentos"
                              v-model="ordencompra.descuentos"
                              decimalLength=0   
                              prefix="$"
                              :readonly="true"                          
                            />
                            <v-currency-field v-else
                               label="Total Descuentos"
                              v-model="ordencompra.descuentos"
                               :prefix="ordencompra.tipoMoneda"
                             :readonly="true"
                            />
                </v-flex>
                 <v-flex xs4>
                    <v-currency-field v-if="ordencompra.tipoMoneda == 'CLP'"
                              label="Total Cargos"
                              v-model="ordencompra.cargos"
                              decimalLength=0   
                              prefix="$"
                              :readonly="true"                          
                            />
                            <v-currency-field v-else
                               label="Total Descuentos"
                              v-model="ordencompra.cargos"
                              :prefix="ordencompra.tipoMoneda"
                             :readonly="true"
                            />
                
                </v-flex>
                 <v-flex xs4>
                  
                   <v-currency-field v-if="ordencompra.tipoMoneda == 'CLP'"
                              label="Total Neto"
                              v-model="ordencompra.totalNeto"
                              decimalLength=0   
                              prefix="$"
                              :readonly="true"                          
                            />
                            <v-currency-field v-else
                               label="Total Neto"
                              v-model="ordencompra.totalNeto"
                              :prefix="ordencompra.tipoMoneda"
                             :readonly="true"
                            />
                </v-flex>
                  <v-flex xs4>
                 
                  
                   <v-currency-field  
                              label="IVA"
                              v-model="ordencompra.porcentajeIva"
                              decimalLength=0   
                              prefix="%"
                              :readonly="true"                          
                            />
                           
                </v-flex>
                 <v-flex xs4>
                  
                  <v-currency-field v-if="ordencompra.tipoMoneda == 'CLP'"
                              label="Total Impuestos"
                              v-model="ordencompra.impuestos"
                              decimalLength=0   
                              prefix="$"
                              :readonly="true"                          
                            />
                            <v-currency-field v-else
                               label="Total Impuestos"
                              v-model="ordencompra.impuestos"
                              :prefix="ordencompra.tipoMoneda"
                             :readonly="true"
                            />
                </v-flex>
                 <v-flex xs4>
                 
                  
                  <v-currency-field v-if="ordencompra.tipoMoneda == 'CLP'"
                              label="Total"
                              v-model="ordencompra.total"
                              decimalLength=0   
                              prefix="$"
                              :readonly="true"                          
                            />
                            <v-currency-field v-else
                               label="Total"
                              v-model="ordencompra.total"
                              :prefix="ordencompra.tipoMoneda"
                             :readonly="true"
                            />
                </v-flex>
                 
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex sm6 v-if="!loading && ordencompra.id > 0">
         <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Mensajes Gestión</h4></v-toolbar-title>
      <v-spacer />
       <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    class="ml-0 pl-0"
                    v-on="on"
                    @click="openAgregarComentario()"
                    slot="activator"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <span>Agregar Comentario</span>
              </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-list two-line class="pa-0 comentarios" >
            <template v-for="(item, index) in detalleComentarios">              
              <v-divider   ></v-divider>
              <v-list-tile avatar   @click="handleClick(item)">                  
                   <v-list-tile-avatar  :color="calculaTipo(item.tipo)">
                 
                   <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon dark v-on="on">{{ item.icon }}</v-icon>
                    </template>
                     <span v-on="on"> {{ item.tipo }}    </span>
                  </v-tooltip> 


                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    
                      <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on"> {{ item.comentario }}    </span>
                    </template>
                    <span> {{ item.tipo }} - {{ item.comentario }}    </span> <br/>
                     <span class='font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioNombre }}</span> &mdash; <span class="font-italic">{{ item.fechaIngreso }} </span>
                  </v-tooltip>               
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                       <span class='text--primary font-italic'> <v-icon>account_circle</v-icon> {{ item.usuarioNombre }}</span> &mdash; <span class="font-italic">{{ item.fechaIngreso }} </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <v-divider></v-divider>
          <!--<v-btn block flat class="ma-0" v-if="items.length > 3">Ver todos</v-btn>-->
          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      </v-flex>
      <v-flex sm12 v-if="!loading">
        <v-card>
          <v-toolbar color="transparent" flat dense card>
            <v-toolbar-title>
              <h4>Items</h4>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text>
            <!--<v-container grid-list-md>-->
            <v-layout wrap>
              <v-flex xs12>
                <v-card>
                  <v-card-text class="mt-0">
                    <v-card-title>
                      <v-btn
                        color="green"
                        small
                        dark
                        @click="getItemsOCExcel(ordencompra.codigo)"
                        slot="activator"
                      >
                        <v-icon>attach_file</v-icon>Descargar Items OC
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar..."
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>

                    <v-data-table
                      :headers="headers"
                      :search="search"
                      :items="detalleItems"
                      :rows-per-page-items="[
                          100,
                          200,
                          300,
                          { text: 'Todos', value: -1 }
                        ]"
                      rows-per-page-text="Registros por página"
                      no-data-text="Sin registros"
                      class="elevation-1"
                      item-key="correlativo"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.correlativo }}</td>
                        <td>{{ props.item.productoDescripcion }}</td>
                        <td>{{ props.item.cantidad }}</td>
                        <td>{{ props.item.moneda }}</td>
                        <td>{{ props.item.especificacionComprador }}</td>
                        <td>{{ props.item.especificacionProveedor }}</td>
                        <td>{{ props.item.precioNetoFormat }}</td>
                        <td>{{ props.item.totalDescuentosFormat }}</td>
                        <td>{{ props.item.totalCargosFormat }}</td>
                        <td>{{ props.item.totalFormat }}</td>
                        <td>
                          <v-btn
                            fab
                            dark
                            small
                            :color="setColorDetalleCorrelativo(props.item.validarLineaIntegracion)"
                            @click="verDetalleCorrelativo(props.item)"
                          >
                           <v-badge 
                          v-model="show"
                          color="purple"
                        >
                          <template v-slot:badge v-if="props.item.observacionesIntegracion">
                            <span>1</span>
                          </template>
                         <v-icon dark v-if="props.item.validarLineaIntegracion === null || props.item.validarLineaIntegracion === false">done</v-icon>
                            <v-icon dark v-else>done_all</v-icon>
                        </v-badge>
                            


                            <!-- SOLO GASCO<v-icon dark v-if="props.item.codigoProductoIntegracion === null">done</v-icon>
                            <v-icon dark v-else>done_all</v-icon> -->
                           <!-- <v-icon dark v-if="props.item.validarLineaIntegracion === null || props.item.validarLineaIntegracion === false">done</v-icon>
                            <v-icon dark v-else>done_all</v-icon> -->
                            <!--<v-icon dark>done_all</v-icon>-->
                          </v-btn>
                        </td>
                      </template>
                      <template slot="pageText" slot-scope="props">
                        Registros {{ props.pageStart }} -
                        {{ props.pageStop }} de
                        {{ props.itemsLength }}
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Su busqueda "{{ search }}" no obtuvo
                        resultados.
                      </v-alert>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <!--</v-container>-->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <loader :value="loading" message="Cargando datos órden de compra" progressColor="blue"></loader>
    <loader :value="loadingEstadoGestion" message="Actualizando estado gestión órden de compra" progressColor="blue"></loader>
  </v-container>
</template>
<!-- 
 //CAMPOS NUEVOS INTEGRACION
        public string EstadoGestion { get; set; }
        public string NroDocumentoIntegracion { get; set; }
        public DateTime? FechaVencimientoIntegracion { get; set; }
        public float? DescuentoGralIntegracion { get; set; }
        public int? TipoDescuentoIntegracion { get; set; }
        public string ObservacionesFavintegracion { get; set; }
        public string CodigoVendedorIntegracion { get; set; }
        public string GlosaPagoIntegracion { get; set; }
        public int? DiaVencimientoIntegracion { get; set; }
        public DateTime? FechaEntregaIntegracion { get; set; }
        public string TipoVentaIntegracion { get; set; }
        public string ObservacionesGuiaIntegracion { get; set; }
        public string HesreferenciaIntegracion { get; set; }
        public DateTime? HesfechaIntegracion { get; set; }
        public string GuiaDespachoIntegracion { get; set; }
        public DateTime? FechaGuiaIntegracion { get; set; }
        public string NroContratoIntegracion { get; set; }
        public DateTime? FechaContratoIntegracion { get; set; }
        public string NroPedidoReferencia { get; set; }        
        public DateTime? FechaPedidoReferencia { get; set; }        
        public string CuentaVentaIntegracion { get; set; }       
        public string NroPedidoIntegracion { get; set; }        
        public DateTime? FechaPedidoIntegracion { get; set; }

-->
<style>
.comentarios {
  height: 400px!important;
  overflow-y: auto!important;
}
.comentarioStatus {
  height: 40px!important; 
} 
.comentarioStatusLineas.v-list--two-line .v-list__tile {
    height: 80px!important;
    margin-bottom: 3px!important;
}
</style>
<script>
import OrdenCompraService from "@/services/OrdenCompraService";
import Loader from "@/components/Loader";
import moment from "moment";
export default {
  components: {
    Loader
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    show: true,
    loadingComentario: false,
    dialogHistorial: false,
    loadingHistorial: false,
    detalleHistorial: [],
    loadingDetalle: false,
    loadingFactores: false,
    loadingNotaVenta: false,
    loadingEstadoGestion: false,
    totalUnitario: 0,
    dialogDetalleNotaVenta: false,
    dialogDetalleCorrelativo: false,
    isLoading: false,
    productosBusqueda: [],
    searchProductos: "",
    rules: {
      required: value => !!value || "campo obligatorio.",
      largoNombre: v => !v || v.length <= 50 || "Max 50 carácteres",
      largo: v => !v || v.length <= 300 || "Max 300 carácteres",
      filtro: value => {
        //const pattern = /[^a-zA-Z0-9\s\\*\(\)\|]+/;
        const pattern = /[a-zA-Z0-9*()"\s]$/; ///[a-zA-Z0-9!@#$%^*_|]/;
        if (!value || value.trim().length > 0) {
          return pattern.test(value) || "filtro con formato incorrecto.";
        }
      }
    },
    integracionDefault: {
      codigoExterno: "",
      nroDocumentoIntegracion: "",
      fechaVencimientoIntegracion: null,
      descuentoGralIntegracion: null,
      tipoDescuentoIntegracion: null,
      observacionesFavintegracion: "",
      codigoVendedorIntegracion: "",
      glosaPagoIntegracion: "",
      diaVencimientoIntegracion: null,
      fechaEntregaIntegracion: null,
      tipoVentaIntegracion: "",
      observacionesGuiaIntegracion: "",
      hesreferenciaIntegracion: "",
      hesfechaIntegracion: null,
      guiaDespachoIntegracion: "",
      fechaGuiaIntegracion: null,
      nroContratoIntegracion: "",
      fechaContratoIntegracion: null,
      nroPedidoReferencia: "",
      fechaPedidoReferencia: null,
      cuentaVentaIntegracion: "",
      nroPedidoIntegracion: "",
      fechaPedidoIntegracion: "",
      menuFechaVencimientoIntegracion: false,
      menufechaEntregaIntegracion: false,
      menuFechaHESIntegracion: false,
      menufechaGuiaIntegracion: false,
      menuFechaContratoIntegracion: false,
      menuFechaPedidoReferencia: false,
      menuFechaPedidoIntegracion: false,
      errorFecha: ""
    },
    integracion: {
      codigoExterno: "",
      nroDocumentoIntegracion: "",
      fechaVencimientoIntegracion: null,
      descuentoGralIntegracion: null,
      tipoDescuentoIntegracion: null,
      observacionesFavintegracion: "",
      codigoVendedorIntegracion: "",
      glosaPagoIntegracion: "",
      diaVencimientoIntegracion: null,
      fechaEntregaIntegracion: null,
      tipoVentaIntegracion: "",
      observacionesGuiaIntegracion: "",
      hesreferenciaIntegracion: "",
      hesfechaIntegracion: null,
      guiaDespachoIntegracion: "",
      fechaGuiaIntegracion: null,
      nroContratoIntegracion: "",
      fechaContratoIntegracion: null,
      nroPedidoReferencia: "",
      fechaPedidoReferencia: null,
      cuentaVentaIntegracion: "",
      nroPedidoIntegracion: "",
      fechaPedidoIntegracion: "",
      menuFechaVencimientoIntegracion: false,
      menufechaEntregaIntegracion: false,
      menuFechaHESIntegracion: false,
      menufechaGuiaIntegracion: false,
      menuFechaContratoIntegracion: false,
      menuFechaPedidoReferencia: false,
      menuFechaPedidoIntegracion: false,
      errorFecha: ""
    },
    detalleItemDefault: {
      id: 0,
      cantidad: 0,
      categoria: "",
      codigoCategoria: 0,
      codigoProducto: 0,
      productoDescripcion: "",
      correlativo: 0,
      codigoOC: "",
      especificacionComprador: "",
      especificacionProveedor: "",
      moneda: "",
      precioNeto: 0,
      precioNetoFormat: "",
      producto: "",
      total: 0,
      totalFormat: "",
      totalCargos: 0,
      totalCargosFormat: "",
      totalDescuentos: 0,
      totalDescuentosFormat: "",
      totalImpuestos: 0,
      codigoProductoIntegracion: "",
      codigoComboIntegracion: null,
      descuentoIntegracion: 0,
      cantidadIntegracion: 0,
      montoUnitarioIntegracion: 0,
      bodegaIntegracion: "",
      centroCostoIntegracion: "",
      descripcionIntegracion: "",
      observacionesIntegracion: "",
      validarLineaIntegracion: false,
      nroContratoIntegracion: "",
      tipoContratoIntegracion: "",
      unidadMedidaIntegracion: "",
      precioIntegracion: 0,
      posicionContratoIntegracion: 0,
      aplicaFactor: false,
      cantidadFactor: 0,
      factorReferencia: 0,
      totalUnitario: 0,
      totalIntegracion: 0,
      factorOriginal: 0,
      
      usuarioValidador: "",
      glosaUsuarioValidador: ""
      /*
  
    ValidarLineaIntegracion = det.ValidarLineaIntegracion,
                        NroContratoIntegracion = det.NroContratoIntegracion,
                        TipoContratoIntegracion = det.TipoContratoIntegracion,
                        UnidadMedidaIntegracion = det.UnidadMedidaIntegracion,
                        PrecioIntegracion = det.PrecioIntegracion,
                        PosicionContratoIntegracion = det.PosicionContratoIntegracion,
                        AplicaFactor = det.AplicaFactor,
                        CantidadFactor = det.CantidadFactor,
                        FactorReferencia = det.FactorReferencia,
  */
    },
    detalleItem: {
      id: 0,
      cantidad: 0,
      categoria: "",
      codigoCategoria: 0,
      codigoProducto: 0,
      productoDescripcion: "",
      correlativo: 0,
      codigoOC: "",
      especificacionComprador: "",
      especificacionProveedor: "",
      moneda: "",
      precioNeto: 0,
      precioNetoFormat: "",
      producto: "",
      total: 0,
      totalFormat: "",
      totalCargos: 0,
      totalCargosFormat: "",
      totalDescuentos: 0,
      totalDescuentosFormat: "",
      totalImpuestos: 0,
      codigoProductoIntegracion: "",
      codigoComboIntegracion: null,
      descuentoIntegracion: 0,
      cantidadIntegracion: 0,
      montoUnitarioIntegracion: 0,
      bodegaIntegracion: "",
      centroCostoIntegracion: "",
      descripcionIntegracion: "",
      observacionesIntegracion: "",
      validarLineaIntegracion: false,
      nroContratoIntegracion: "",
      tipoContratoIntegracion: "",
      unidadMedidaIntegracion: "",
      precioIntegracion: 0,
      posicionContratoIntegracion: 0,
      aplicaFactor: false,
      cantidadFactor: 0,
      factorReferencia: 0,
      totalUnitario: 0,
      totalIntegracion: 0,
      factorOriginal: 0,
      usuarioValidador: "",
      glosaUsuarioValidador: ""
    },
    codigo: "",
    search: "",
    rowsPerPageItems: [100, 200, 300],
    pagination: {
      page: 1,
      rowsPerPage: 100,
      sortBy: "correlativo",
      descending: true
    },
    loading: true,
    ordencompra: {},
    detalleItems: [],
    detalleComentarios: [],
    dialogComentario: false,
    selectComentario:  { name: 'Informativo', icon: 'info' },
    tiposComentario: [
       
        { name: 'Informativo', icon: 'info' },
        { name: 'Consulta', icon: 'help'}       
      ]
    ,
    tempComentario: "",
    headers: [
      {
        text: "Corr.",
        align: "left",
        sortable: true,
        value: "correlativo"
      },
      {
        text: "Producto",
        align: "left",
        sortable: true,
        value: "productoDescripcion"
      },
      {
        text: "Cantidad / Unidad",
        align: "left",
        sortable: true,
        value: "cantidad"
      },
      {
        text: "Moneda",
        align: "left",
        sortable: true,
        value: "moneda"
      },
      {
        text: "Esp. Comprador",
        align: "left",
        sortable: true,
        value: "especificacionComprador"
      },
      {
        text: "Esp. Proveedor",
        align: "left",
        sortable: true,
        value: "especificacionProveedor"
      },
      {
        text: "Precio Neto",
        align: "left",
        sortable: true,
        value: "precioNeto"
      },
      {
        text: "Total Descuentos",
        align: "left",
        sortable: true,
        value: "totalDescuentos"
      },
      {
        text: "Total Cargos",
        align: "left",
        sortable: true,
        value: "totalCargos"
      },
      {
        text: "Total",
        align: "left",
        sortable: true,
        value: "total"
      }
    ]
  }),
  methods: {
      calculaTipo(tipo)
    {
       if (tipo === "Informativo") {
        return "blue";
      } else if (tipo === "Consulta") {
        return "orange";      
      } else {
        return "grey";
      }
    },
    guardarComentario()
    {
      debugger; 
       if (!this.$refs.formComentario.validate())
      {
        return;
      }
       
      this.loadingComentario = true;
                  const response = OrdenCompraService.createComentario(
                 this.codigo,
                  this.tempComentario,
                  this.selectComentario.name
                )
                  .then(r => {
                      
                     debugger; 
                const comentariosResponse = OrdenCompraService.findComentarios(this.ordencompra.id)
                .then(r => {
                    debugger;
                    this.detalleComentarios = r.data                
                    this.loadingComentario = false;
                    this.cancelarComentario();
                }).catch(r => {
                   debugger;
                  this.loadingComentario = false;
                  console.log(r.response);
                 
                });


 
                  })
                  .catch(r => {
                    this.loadingComentario = false;
                    
                    this.snackbar = {
            show: true,
            color: 'red',
            text: r.response.data.mensaje
          };
           
                    console.log(r.response);
                  });
          
    },
    modalDetalleVenta() {
      this.dialogDetalleNotaVenta = true;
    },
    cleanDetalleNotaVenta() {
      this.dialogDetalleNotaVenta = false;
    },
     cleanHistorial() {
      this.dialogHistorial = false;
    },
    cleanDetalleOC() {
      this.dialogDetalleCorrelativo = false;
      //this.detalleItem = Object.assign({}, this.detalleItemDefault);
    },
    setNotaVentaColorStatus(value)
    {
      debugger;
        //SOLO GASCO return value === undefined || value === null || value === false ? "orange" : "green";
        return "green";
    },
    checkSaveNotaVentas()
    {     
      debugger;
      if(this.detalleItems)
      {
        /*
          const items = this.detalleItems.filter(item => item.codigoProductoIntegracion != null || item.codigoProductoIntegracion != undefined).length;
          const hasNotaVenta = this.ordencompra.hasInfoIntegracion;      
          const hasStatus = this.ordencompra.estadoGestion == "PENDIENTE VALIDACION";    
          return !(items > 0 && hasNotaVenta && hasStatus);
          */ 
         /* update 07072020
         const hasStatus = this.ordencompra.estadoGestion == "PENDIENTE VALIDACION";    
         return !(hasStatus);
         */
         
          const hasStatus = this.ordencompra.estadoGestion == "PENDIENTE VALIDACION";    
         return !(hasStatus);

      }
      else
      {
        return true;
      }     
    }
    ,
      setColorEstado(value) {
      //SOLO GASCO return value === undefined || value === null ? "orange" : "green";
      /*
      Aceptada
Enviada a proveedor
Cancelada
Recepción Conforme
      */
      if(value === "Aceptada" || value === "Recepción Conforme")
      {
        return "green";
      }
      else if (value === "Cancelada")
      {
        return "red"
      }
      else{
        return "blue darken-1"
      }
         
    } 
    ,
    isReadOnlyDetalle()
    {
      return this.ordencompra.estadoGestion === "PENDIENTE VALIDACION" && this.ordencompra.clienteEditable === true ? false : true;
    }
    ,
    setColorDetalleCorrelativo(value) {
      //SOLO GASCO return value === undefined || value === null ? "orange" : "green";
      //return "green";
      return value === undefined || value === null || value === false ? "orange" : "green";
    },
    setIconDetalleCorrelativo(icon) {
      //SOLO GASCO return value === undefined || value === null ? "done" : "done_all";
      return "done_all";
    },
    irLicitacion(item) {
      var link = "https://www.mercadopublico.cl/Procurement/Modules/RFB/DetailsAcquisition.aspx?idlicitacion="+item;
      window.open(link, "_blank");
    },
    /*detalle item integracion
    async saveDetalleItem() {
      debugger;

      let codigoArticulo = null;
      if(this.detalleItem.codigoComboIntegracion)
      {
        codigoArticulo = this.detalleItem.codigoComboIntegracion.codigoArticulo;
      }
      
        //updateInfoIntegracionDetalle
      let objDetalleOC = {
            id: this.detalleItem.id,
            correlativo: this.detalleItem.correlativo,
            codigoProductoIntegracion: codigoArticulo,
            descuentoIntegracion: this.detalleItem.descuentoIntegracion,
            cantidadIntegracion: this.detalleItem.cantidadIntegracion,
            montoUnitarioIntegracion: this.detalleItem.montoUnitarioIntegracion,
            bodegaIntegracion: this.detalleItem.bodegaIntegracion,
            centroCostoIntegracion: this.detalleItem.centroCostoIntegracion,
            descripcionIntegracion: this.detalleItem.descripcionIntegracion,
            observacionesIntegracion: this.detalleItem.observacionesIntegracion,
            validarLineaIntegracion: true,
            nroContratoIntegracion: this.detalleItem.nroContratoIntegracion,
            tipoContratoIntegracion: this.detalleItem.tipoContratoIntegracion,
            unidadMedidaIntegracion: this.detalleItem.unidadMedidaIntegracion,
            precioIntegracion: this.detalleItem.precioIntegracion,
            posicionContratoIntegracion: this.detalleItem.posicionContratoIntegracion,
            aplicaFactor: this.detalleItem.aplicaFactor,
            cantidadFactor: this.detalleItem.cantidadFactor,
            factorReferencia: this.detalleItem.factorReferencia,
      };
      this.loadingDetalle = true;
        await OrdenCompraService.updateInfoIntegracionDetalle(
          objDetalleOC
        ).then(r => {         
            debugger;
             this.loadingDetalle = false;
            const itemIndex = this.detalleItems.findIndex(item => item.id == objDetalleOC.id && item.correlativo ==objDetalleOC.correlativo);
            this.detalleItems[itemIndex].codigoProductoIntegracion= codigoArticulo;
            this.detalleItems[itemIndex].descuentoIntegracion= this.detalleItem.descuentoIntegracion;
            this.detalleItems[itemIndex].cantidadIntegracion= this.detalleItem.cantidadIntegracion;
            this.detalleItems[itemIndex].montoUnitarioIntegracion= this.detalleItem.montoUnitarioIntegracion;
            this.detalleItems[itemIndex].bodegaIntegracion= this.detalleItem.bodegaIntegracion;
            this.detalleItems[itemIndex].centroCostoIntegracion= this.detalleItem.centroCostoIntegracion;
            this.detalleItems[itemIndex].descripcionIntegracion= this.detalleItem.descripcionIntegracion;
            this.detalleItems[itemIndex].observacionesIntegracion= this.detalleItem.observacionesIntegracion;
            this.detalleItems[itemIndex].validarLineaIntegracion= true;
            this.detalleItems[itemIndex].nroContratoIntegracion= this.detalleItem.nroContratoIntegracion;
            this.detalleItems[itemIndex].tipoContratoIntegracion= this.detalleItem.tipoContratoIntegracion;
            this.detalleItems[itemIndex].unidadMedidaIntegracion= this.detalleItem.unidadMedidaIntegracion;
            this.detalleItems[itemIndex].precioIntegracion= this.detalleItem.precioIntegracion;
            this.detalleItems[itemIndex].posicionContratoIntegracion= this.detalleItem.posicionContratoIntegracion;
            this.detalleItems[itemIndex].aplicaFactor= this.detalleItem.aplicaFactor;
            this.detalleItems[itemIndex].cantidadFactor= this.detalleItem.cantidadFactor;
            this.detalleItems[itemIndex].factorReferencia= this.detalleItem.factorReferencia; 


           this.snackbar = {
                show: true,
                color: "green",
                text: "Información integración grabada con éxito"
              };
        }).catch(error => {
              // Failed
            debugger;
             this.loadingDetalle = false;
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error al actualizar información de integración"
              };
            });;
    },
    */
   async saveDetalleItem() {
      debugger;

      
        //updateInfoIntegracionDetalle
      let objDetalleOC = {
            id: this.detalleItem.id,
            correlativo: this.detalleItem.correlativo,
            codigoProductoIntegracion: null,
            descuentoIntegracion: this.detalleItem.descuentoIntegracion,
            cantidadIntegracion: this.detalleItem.cantidadIntegracion,
            montoUnitarioIntegracion: this.detalleItem.montoUnitarioIntegracion,
            bodegaIntegracion: this.detalleItem.bodegaIntegracion,
            centroCostoIntegracion: this.detalleItem.centroCostoIntegracion,
            descripcionIntegracion: this.detalleItem.descripcionIntegracion,
            observacionesIntegracion: this.detalleItem.observacionesIntegracion,
            validarLineaIntegracion: this.detalleItem.validarLineaIntegracion,
            nroContratoIntegracion: this.detalleItem.nroContratoIntegracion,
            tipoContratoIntegracion: this.detalleItem.tipoContratoIntegracion,
            unidadMedidaIntegracion: this.detalleItem.unidadMedidaIntegracion,
            precioIntegracion: this.detalleItem.precioIntegracion,
            posicionContratoIntegracion: this.detalleItem.posicionContratoIntegracion,
            aplicaFactor: this.detalleItem.aplicaFactor,
            cantidadFactor: this.detalleItem.cantidadFactor,
            factorReferencia: this.detalleItem.factorReferencia,
      };
      this.loadingDetalle = true;
        await OrdenCompraService.updateInfoIntegracionDetalle(
          objDetalleOC
        ).then(r => {         
            debugger;
             this.loadingDetalle = false;
            const itemIndex = this.detalleItems.findIndex(item => item.id == objDetalleOC.id && item.correlativo ==objDetalleOC.correlativo);
            this.detalleItems[itemIndex].codigoProductoIntegracion= null;
            this.detalleItems[itemIndex].descuentoIntegracion= this.detalleItem.descuentoIntegracion;
            this.detalleItems[itemIndex].cantidadIntegracion= this.detalleItem.cantidadIntegracion;
            this.detalleItems[itemIndex].montoUnitarioIntegracion= this.detalleItem.montoUnitarioIntegracion;
            this.detalleItems[itemIndex].bodegaIntegracion= this.detalleItem.bodegaIntegracion;
            this.detalleItems[itemIndex].centroCostoIntegracion= this.detalleItem.centroCostoIntegracion;
            this.detalleItems[itemIndex].descripcionIntegracion= this.detalleItem.descripcionIntegracion;
            this.detalleItems[itemIndex].observacionesIntegracion= this.detalleItem.observacionesIntegracion;
            this.detalleItems[itemIndex].validarLineaIntegracion= this.detalleItem.validarLineaIntegracion;
            this.detalleItems[itemIndex].nroContratoIntegracion= this.detalleItem.nroContratoIntegracion;
            this.detalleItems[itemIndex].tipoContratoIntegracion= this.detalleItem.tipoContratoIntegracion;
            this.detalleItems[itemIndex].unidadMedidaIntegracion= this.detalleItem.unidadMedidaIntegracion;
            this.detalleItems[itemIndex].precioIntegracion= this.detalleItem.precioIntegracion;
            this.detalleItems[itemIndex].posicionContratoIntegracion= this.detalleItem.posicionContratoIntegracion;
            this.detalleItems[itemIndex].aplicaFactor= this.detalleItem.aplicaFactor;
            this.detalleItems[itemIndex].cantidadFactor= this.detalleItem.cantidadFactor;
            this.detalleItems[itemIndex].factorReferencia= this.detalleItem.factorReferencia; 
            this.detalleItems[itemIndex].usuarioValidador= r.data.detalle; 
            this.detalleItems[itemIndex].glosaUsuarioValidador= r.data.detalle; 
            this.detalleItem.usuarioValidador= r.data.detalle; 
            this.detalleItem.glosaUsuarioValidador= r.data.detalle; 
           this.snackbar = {
                show: true,
                color: "green",
                text: "Información grabada con éxito"
              };
        }).catch(error => {
              // Failed
            debugger;
             this.loadingDetalle = false;
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error al actualizar información"
              };
            });;
    },
    async saveDetalleNotaVenta() {
      debugger;
       
      let objOC = {

           codigo: this.ordencompra.codigo,
            nroDocumentoIntegracion: this.integracion.nroDocumentoIntegracion,
            fechaVencimientoIntegracion: this.integracion.fechaVencimientoIntegracion,
            descuentoGralIntegracion: this.integracion.descuentoGralIntegracion,
            tipoDescuentoIntegracion: this.integracion.tipoDescuentoIntegracion,
            observacionesFavintegracion: this.integracion.observacionesFavintegracion,
            codigoVendedorIntegracion:  this.integracion.codigoVendedorIntegracion,
            glosaPagoIntegracion: this.integracion.glosaPagoIntegracion,
            diaVencimientoIntegracion: this.integracion.diaVencimientoIntegracion,
            fechaEntregaIntegracion: this.integracion.fechaEntregaIntegracion,
            tipoVentaIntegracion: this.integracion.tipoVentaIntegracion,
            observacionesGuiaIntegracion: this.integracion.observacionesGuiaIntegracion,
            hesreferenciaIntegracion: this.integracion.hesreferenciaIntegracion,
            hesfechaIntegracion:  this.integracion.hesfechaIntegracion,
            guiaDespachoIntegracion:  this.integracion.guiaDespachoIntegracion,
            fechaGuiaIntegracion:  this.integracion.fechaGuiaIntegracion,
            nroContratoIntegracion: this.integracion.nroContratoIntegracion,
            fechaContratoIntegracion:  this.integracion.fechaContratoIntegracion,
            nroPedidoReferencia: this.integracion.nroPedidoReferencia,
            fechaPedidoReferencia: this.integracion.fechaPedidoReferencia,
            cuentaVentaIntegracion: this.integracion.cuentaVentaIntegracion,
            nroPedidoIntegracion:  this.integracion.nroPedidoIntegracion,
            fechaPedidoIntegracion:  this.integracion.fechaPedidoIntegracion,

      }
      this.loadingNotaVenta = true;
        await OrdenCompraService.updateInfoIntegracion(
          objOC
        ).then(r => {
          //this.detalleItem.codigoComboIntegracion = r.data
            this.ordencompra.codigoExterno = this.integracion.codigoExterno;
            this.ordencompra.nroDocumentoIntegracion = this.integracion.nroDocumentoIntegracion;
            this.ordencompra.fechaVencimientoIntegracion = this.integracion.fechaVencimientoIntegracion;
            this.ordencompra.descuentoGralIntegracion = this.integracion.descuentoGralIntegracion;
            this.ordencompra.tipoDescuentoIntegracion = this.integracion.tipoDescuentoIntegracion;
            this.ordencompra.observacionesFavintegracion = this.integracion.observacionesFavintegracion;
            this.ordencompra.codigoVendedorIntegracion = this.integracion.codigoVendedorIntegracion;
            this.ordencompra.glosaPagoIntegracion = this.integracion.glosaPagoIntegracion;
            this.ordencompra.diaVencimientoIntegracion = this.integracion.diaVencimientoIntegracion;
            this.ordencompra.fechaEntregaIntegracion = this.integracion.fechaEntregaIntegracion;
            this.ordencompra.tipoVentaIntegracion = this.integracion.tipoVentaIntegracion;
            this.ordencompra.observacionesGuiaIntegracion = this.integracion.observacionesGuiaIntegracion;
            this.ordencompra.hesreferenciaIntegracion = this.integracion.hesreferenciaIntegracion;
            this.ordencompra.hesfechaIntegracion = this.integracion.hesfechaIntegracion;
            this.ordencompra.guiaDespachoIntegracion = this.integracion.guiaDespachoIntegracion;
            this.ordencompra.fechaGuiaIntegracion = this.integracion.fechaGuiaIntegracion;
            this.ordencompra.nroContratoIntegracion = this.integracion.nroContratoIntegracion;
            this.ordencompra.fechaContratoIntegracion = this.integracion.fechaContratoIntegracion;
            this.ordencompra.nroPedidoReferencia = this.integracion.nroPedidoReferencia;
            this.ordencompra.fechaPedidoReferencia = this.integracion.fechaPedidoReferencia;
            this.ordencompra.fechaPedidoIntegracion = this.integracion.fechaPedidoIntegracion; 
            this.ordencompra.cuentaVentaIntegracion = this.integracion.cuentaVentaIntegracion;
            this.ordencompra.nroPedidoIntegracion = this.integracion.nroPedidoIntegracion;


            this.integracion.codigoExterno = this.ordencompra.codigo;
            this.integracion.nroDocumentoIntegracion = this.ordencompra.nroDocumentoIntegracion;
            this.integracion.fechaVencimientoIntegracion = this.ordencompra.fechaVencimientoIntegracion;
            this.integracion.descuentoGralIntegracion = this.ordencompra.descuentoGralIntegracion;
            this.integracion.tipoDescuentoIntegracion = this.ordencompra.tipoDescuentoIntegracion;
            this.integracion.observacionesFavintegracion = this.ordencompra.observacionesFavintegracion;
            this.integracion.codigoVendedorIntegracion = this.ordencompra.codigoVendedorIntegracion;
            this.integracion.glosaPagoIntegracion = this.ordencompra.glosaPagoIntegracion;
            this.integracion.diaVencimientoIntegracion = this.ordencompra.diaVencimientoIntegracion;
            this.integracion.fechaEntregaIntegracion = this.ordencompra.fechaEntregaIntegracion;
            this.integracion.tipoVentaIntegracion = this.ordencompra.tipoVentaIntegracion;
            this.integracion.observacionesGuiaIntegracion = this.ordencompra.observacionesGuiaIntegracion;
            this.integracion.hesreferenciaIntegracion = this.ordencompra.hesreferenciaIntegracion;
            this.integracion.hesfechaIntegracion = this.ordencompra.hesfechaIntegracion;
            this.integracion.guiaDespachoIntegracion = this.ordencompra.guiaDespachoIntegracion;
            this.integracion.fechaGuiaIntegracion = this.ordencompra.fechaGuiaIntegracion;
            this.integracion.nroContratoIntegracion = this.ordencompra.nroContratoIntegracion;
            this.integracion.fechaContratoIntegracion = this.ordencompra.fechaContratoIntegracion;
            this.integracion.nroPedidoReferencia = this.ordencompra.nroPedidoReferencia;
            this.integracion.fechaPedidoReferencia = this.ordencompra.fechaPedidoReferencia;
            this.integracion.fechaPedidoIntegracion = this.ordencompra.fechaPedidoIntegracion;
            this.integracion.cuentaVentaIntegracion = this.ordencompra.cuentaVentaIntegracion;
            this.integracion.nroPedidoIntegracion = this.ordencompra.nroPedidoIntegracion;
            /*
            this.integracionDefault.codigoExterno = this.ordencompra.codigo;
            this.integracionDefault.nroDocumentoIntegracion = this.ordencompra.nroDocumentoIntegracion;
            this.integracionDefault.fechaVencimientoIntegracion = this.ordencompra.fechaVencimientoIntegracion;
            this.integracionDefault.descuentoGralIntegracion = this.ordencompra.descuentoGralIntegracion;
            this.integracionDefault.tipoDescuentoIntegracion = this.ordencompra.tipoDescuentoIntegracion;
            this.integracionDefault.observacionesFavintegracion = this.ordencompra.observacionesFavintegracion;
            this.integracionDefault.codigoVendedorIntegracion = this.ordencompra.codigoVendedorIntegracion;
            this.integracionDefault.glosaPagoIntegracion = this.ordencompra.glosaPagoIntegracion;
            this.integracionDefault.diaVencimientoIntegracion = this.ordencompra.diaVencimientoIntegracion;
            this.integracionDefault.fechaEntregaIntegracion = this.ordencompra.fechaEntregaIntegracion;
            this.integracionDefault.tipoVentaIntegracion = this.ordencompra.tipoVentaIntegracion;
            this.integracionDefault.observacionesGuiaIntegracion = this.ordencompra.observacionesGuiaIntegracion;
            this.integracionDefault.hesreferenciaIntegracion = this.ordencompra.hesreferenciaIntegracion;
            this.integracionDefault.hesfechaIntegracion = this.ordencompra.hesfechaIntegracion;
            this.integracionDefault.guiaDespachoIntegracion = this.ordencompra.guiaDespachoIntegracion;
            this.integracionDefault.fechaGuiaIntegracion = this.ordencompra.fechaGuiaIntegracion;
            this.integracionDefault.nroContratoIntegracion = this.ordencompra.nroContratoIntegracion;
            this.integracionDefault.fechaContratoIntegracion = this.ordencompra.fechaContratoIntegracion;
            this.integracionDefault.nroPedidoReferencia = this.ordencompra.nroPedidoReferencia;
            this.integracionDefault.fechaPedidoReferencia = this.ordencompra.fechaPedidoReferencia;
            this.integracionDefault.fechaPedidoIntegracion = this.ordencompra.fechaPedidoIntegracion;
            this.integracionDefault.cuentaVentaIntegracion = this.ordencompra.cuentaVentaIntegracion;
            this.integracionDefault.nroPedidoIntegracion = this.ordencompra.nroPedidoIntegracion;
*/
          this.loadingNotaVenta = false;

          this.ordencompra.hasInfoIntegracion = (this.ordencompra.nroDocumentoIntegracion.length > 0);
           this.snackbar = {
                show: true,
                color: "green",
                text: "Información integración grabada con éxito"
              };
        }).catch(error => {
              // Failed
            debugger;
             this.loadingNotaVenta = false;
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error al actualizar información de integración"
              };
            });;
      
    },
     calculaStatus(estado) {
      if (estado === "PENDIENTE ACEPTACION") {
        return "deep-purple darken-1";
      } else if (estado === "CANCELADA") {
        return "red";
      } else if (estado === "VALIDADA" || estado === "ACEPTADA" || estado === "RECEPCION CONFORME") {
        return "green";
      } else if (estado === "PENDIENTE VALIDACION") {
        return "blue darken-1";
      }else {
        return "grey";
      }
    },
   
    async updateEstadoIntegracion()
    {
debugger;
      var itemsNoValidados = this.detalleItems.filter(item => (item.validarLineaIntegracion == null || item.validarLineaIntegracion == undefined) || item.validarLineaIntegracion == false  ).length;
      if(itemsNoValidados > 0)
      {
         this.snackbar = {
                show: true,
                color: "red",
                text: "Debe validar todos los items."
              };
              return;
      }


      this.loadingEstadoGestion = true;
      this.ordencompra.estadoGestion = "PENDIENTE ACEPTACION";
       const estado = await OrdenCompraService.updateEstadoIntegracion(
          this.ordencompra
        ).then(r => {
          //this.detalleItem.codigoComboIntegracion = r.data
          this.loadingEstadoGestion = false;
           this.snackbar = {
                show: true,
                color: "green",
                text: "Órden de compra validada con éxito."
              };
        }).catch(error => {
              // Failed
              this.ordencompra.estadoGestion = "PENDIENTE VALIDACION";
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error al cambiar de estado de gestión la órden de compra."
              };
            });
;
    },
    async updateEstadoAceptacion()
    {
      if(this.ordencompra.estadoGestion === "PENDIENTE ACEPTACION")
      {
        debugger;
          this.$refs.confirm
        .open(
          "Confirmar Aceptación OC en Mercado Público ",
          "La confirmación de aceptación debe realizarse en la plataforma Mercado Público, y tiene un tiempo de actualización de 15 minutos contra la plataforma.",
          {
            color: "orange",
            width: 500
          }
          ,
           true
        )
        .then((confirm) => {
          if (confirm) {
             
               this.loadingEstadoGestion = true;
            this.ordencompra.estadoGestion = "ACEPTADA";
            const estado = OrdenCompraService.updateEstadoIntegracion(
                this.ordencompra
              ).then(r => {
                //this.detalleItem.codigoComboIntegracion = r.data
                this.loadingEstadoGestion = false;
                this.snackbar = {
                      show: true,
                      color: "green",
                      text: "Órden de compra aceptada con éxito."
                    };
              }).catch(error => {
                    // Failed
                    this.ordencompra.estadoGestion = "PENDIENTE ACEPTACION";
                    this.snackbar = {
                      show: true,
                      color: "red",
                      text: "Error al cambiar de estado de gestión la órden de compra."
                    };
                  });


          }
        });
      }
         
     
;
    }
    ,
    async cancelDetalleNotaVenta() {
      debugger;
      this.integracion = Object.assign(
        this.integracion,
        this.integracionDefault
      );
      //this.integracionDefault.codigoExterno = this.ordencompra.codigoExterno;
      this.integracion.codigoExterno = this.ordencompra.codigoExterno;
      this.ordencompra.hasInfoIntegracion = false;
    },
    async cancelDetalleItem() {
      debugger;
      
      
      this.detalleItem.codigoComboIntegracion = null;

            const itemIndex = this.detalleItems.findIndex(item => item.id == this.detalleItem.id && item.correlativo ==this.detalleItem.correlativo);
            this.detalleItems[itemIndex].codigoProductoIntegracion= this.detalleItemDefault.codigoProductoIntegracion; 
            this.detalleItems[itemIndex].descuentoIntegracion= this.detalleItemDefault.descuentoIntegracion;
            this.detalleItems[itemIndex].cantidadIntegracion= this.detalleItemDefault.cantidadIntegracion;
            this.detalleItems[itemIndex].montoUnitarioIntegracion= this.detalleItemDefault.montoUnitarioIntegracion;
            this.detalleItems[itemIndex].bodegaIntegracion= this.detalleItemDefault.bodegaIntegracion;
            this.detalleItems[itemIndex].centroCostoIntegracion= this.detalleItemDefault.centroCostoIntegracion;
            this.detalleItems[itemIndex].descripcionIntegracion= this.detalleItemDefault.descripcionIntegracion;
            this.detalleItems[itemIndex].observacionesIntegracion= this.detalleItemDefault.observacionesIntegracion;
            this.detalleItems[itemIndex].validarLineaIntegracion= false;
            this.detalleItems[itemIndex].nroContratoIntegracion= this.detalleItemDefault.nroContratoIntegracion;
            this.detalleItems[itemIndex].tipoContratoIntegracion= this.detalleItemDefault.tipoContratoIntegracion;
            this.detalleItems[itemIndex].unidadMedidaIntegracion= this.detalleItemDefault.unidadMedidaIntegracion;
            this.detalleItems[itemIndex].precioIntegracion= this.detalleItemDefault.precioIntegracion;
            this.detalleItems[itemIndex].posicionContratoIntegracion= this.detalleItemDefault.posicionContratoIntegracion;
            this.detalleItems[itemIndex].aplicaFactor= this.detalleItemDefault.aplicaFactor;
            this.detalleItems[itemIndex].cantidadFactor= this.detalleItemDefault.cantidadFactor;
            this.detalleItems[itemIndex].factorReferencia= this.detalleItemDefault.factorReferencia; 
            await this.setCalculateTotales();

    },
    async setProducto() {
      debugger;

      if (this.detalleItem.codigoComboIntegracion != null) {
        const articuloExistente = await OrdenCompraService.getArticuloByCodigo(
          this.detalleItem.codigoComboIntegracion.codigoArticulo
        ).then(r => {
          //this.detalleItem.codigoComboIntegracion = r.data
          return r.data;
        });

        if (articuloExistente == "") {
          //no existe el producto por lo cual debe dejar todo en null
          this.detalleItem.aplicaFactor = false;
          this.detalleItem.cantidadFactor = 0;
          this.detalleItem.cantidadIntegracion = 0;
          this.detalleItem.factorReferencia = 0;
          this.detalleItem.unidadMedidaIntegracion = "";
          this.detalleItem.codigoComboIntegracion = null;
          this.detalleItem.totalUnitario = this.detalleItem.total;
          this.detalleItem.totalIntegracion = 0;
          this.detalleItem.factorOriginal = 0;
        } else {
          const precioArticulo = await OrdenCompraService.getPrecioArticulo(
            this.codigo,
            this.detalleItem.codigoComboIntegracion.codigoArticulo
          )
            .then(r => {
              return r.data;
            })
            .catch(error => {
              // Failed

              this.snackbar = {
                show: true,
                color: "red",
                text: error.response.data.error
              };
            });

          if (precioArticulo != undefined) {
            if (precioArticulo.codigoContrato != undefined) {
              this.detalleItem.nroContratoIntegracion =
                precioArticulo.codigoContrato;
              this.detalleItem.posicionContratoIntegracion =
                precioArticulo.linea;
            }

            //logica factor

            let factor = 1;
            if (this.detalleItem.aplicaFactor == true) {
              factor = this.detalleItem.cantidadFactor;
            } else {
              // this.detalleItem.cantidadFactor = articuloExistente.factorEmpaque;
              this.detalleItem.cantidadFactor = factor;
            }

            var cantiadadEnvioSac = parseFloat(this.detalleItem.cantidad);
            var montoEnvioSac = parseFloat(precioArticulo.precioLista);
            ///Precio Total real de la OC
            var montoTotalEnvioSac =
              parseFloat(precioArticulo.precioLista) +
              parseFloat(this.detalleItem.totalImpuestos) +
              parseFloat(this.detalleItem.totalCargos) -
              parseFloat(this.detalleItem.totalDescuentos);
            ///Empaquetado del producto
            var num = cantiadadEnvioSac / factor;
            ///Redondeo hacia abajo
            var floored_num = num - (num % 1); // floored_num will be 3
            ///Cantidad de nuevos elementos redondeados hacia abajo
            var nuevaCantidadEnvio = floored_num.toFixed();

            if (nuevaCantidadEnvio === "0") {
              this.snackbar = {
                show: true,
                color: "red",
                text:
                  "Factor de empaque es superior a las cantidades del producto."
              };
              //$("#AplicaFactor").prop('checked', false);
              //RestauraMontosEnvioSac();
              this.loadingFactores = false;
              return;
            }

            var nuevoMontoEnvio = ((montoTotalEnvioSac * factor) / 1).toFixed();

            ///////////////////////////////////////////////
            /*this.detalleItem.tipoContratoIntegracion = precioArticulo.tipo;
                            this.detalleItem.precioIntegracion = precioArticulo.precioLista;
                            this.detalleItem.totalUnitario  = (parseFloat(this.detalleItem.precioIntegracion) 
                                                              + parseFloat(this.detalleItem.totalImpuestos)
                                                              + parseFloat(this.detalleItem.totalCargos)
                                                              - parseFloat(this.detalleItem.totalDescuentos) / factor) ;
                            this.detalleItem.totalIntegracion  = ((parseFloat(this.detalleItem.precioIntegracion) 
                                                              + parseFloat(this.detalleItem.totalImpuestos)
                                                              + parseFloat(this.detalleItem.totalCargos)
                                                              - parseFloat(this.detalleItem.totalDescuentos)) / factor) * parseFloat(this.detalleItem.cantidad) ;
                            let totalTemp = (parseFloat(this.detalleItem.precioNeto) 
                                                              + parseFloat(this.detalleItem.totalImpuestos)
                                                              + parseFloat(this.detalleItem.totalCargos)
                                                              - parseFloat(this.detalleItem.totalDescuentos) ) / factor;*/
            this.detalleItem.tipoContratoIntegracion = precioArticulo.tipo;
            this.detalleItem.precioIntegracion = montoEnvioSac;
            this.detalleItem.totalUnitario = nuevoMontoEnvio;
            this.detalleItem.totalIntegracion =
              nuevoMontoEnvio * nuevaCantidadEnvio;
            let totalTemp = nuevoMontoEnvio * nuevaCantidadEnvio;
            this.detalleItem.cantidadIntegracion = nuevaCantidadEnvio;
            this.loadingFactores = false;

            if (this.detalleItem.total != totalTemp) {
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error en cuadratura de totales, favor revisar"
              };
            }
          }

          this.detalleItem.aplicaFactor = false;
          this.detalleItem.cantidadFactor = articuloExistente.factorEmpaque;
          this.detalleItem.factorReferencia = articuloExistente.factorEmpaque;
          this.detalleItem.unidadMedidaIntegracion =
            articuloExistente.unidadMedidaVenta;
          this.detalleItem.factorOriginal = articuloExistente.factorEmpaque;
        }
      }
    },
    async setCalculateTotales() {
      this.loadingFactores = true;
      if (this.detalleItem.codigoComboIntegracion != null) {
        const articuloExistente = await OrdenCompraService.getArticuloByCodigo(
          this.detalleItem.codigoComboIntegracion.codigoArticulo
        ).then(r => {
          //this.detalleItem.codigoComboIntegracion = r.data
          return r.data;
        });

        if (articuloExistente == "") {
          //no existe el producto por lo cual debe dejar todo en null
          this.detalleItem.aplicaFactor = false;
          this.detalleItem.cantidadFactor = 0;
          this.detalleItem.factorReferencia = 0;
          this.detalleItem.unidadMedidaIntegracion = "";
          this.detalleItem.codigoComboIntegracion = null;
          this.detalleItem.totalUnitario = this.detalleItem.total;
          this.detalleItem.totalIntegracion = 0;
          this.detalleItem.factorOriginal = 0;
          this.loadingFactores = false;
        } else {
          const precioArticulo = await OrdenCompraService.getPrecioArticulo(
            this.codigo,
            this.detalleItem.codigoComboIntegracion.codigoArticulo
          )
            .then(r => {
              return r.data;
            })
            .catch(error => {
              // Failed
              this.loadingFactores = false;

              this.snackbar = {
                show: true,
                color: "red",
                text: error.response.data.error
              };
            });

          if (precioArticulo != undefined && this.ordencompra.estadoGestion == "PENDIENTE VALIDACION") {
            debugger;
            if (precioArticulo.codigoContrato != undefined) {
              this.detalleItem.nroContratoIntegracion =
                precioArticulo.codigoContrato;
              this.detalleItem.posicionContratoIntegracion =
                precioArticulo.linea;
            }
            //logica factor

            let factor = 1;
            if (this.detalleItem.aplicaFactor == true) {
              factor = this.detalleItem.cantidadFactor;
            } else {
              // this.detalleItem.cantidadFactor = articuloExistente.factorEmpaque;
              this.detalleItem.cantidadFactor = factor;
            }

            var cantiadadEnvioSac = parseFloat(this.detalleItem.cantidad);
            var montoEnvioSac = parseFloat(precioArticulo.precioLista);
            ///Precio Total real de la OC
            var montoTotalEnvioSac =
              parseFloat(precioArticulo.precioLista) +
              parseFloat(this.detalleItem.totalImpuestos) +
              parseFloat(this.detalleItem.totalCargos) -
              parseFloat(this.detalleItem.totalDescuentos);
            ///Empaquetado del producto
            var num = cantiadadEnvioSac / factor;
            ///Redondeo hacia abajo
            var floored_num = num - (num % 1); // floored_num will be 3
            ///Cantidad de nuevos elementos redondeados hacia abajo
            var nuevaCantidadEnvio = floored_num.toFixed();

            if (nuevaCantidadEnvio === "0") {
              this.snackbar = {
                show: true,
                color: "red",
                text:
                  "Factor de empaque es superior a las cantidades del producto."
              };
              //$("#AplicaFactor").prop('checked', false);
              //RestauraMontosEnvioSac();
              this.loadingFactores = false;
              return;
            }

            var nuevoMontoEnvio = ((montoTotalEnvioSac * factor) / 1).toFixed();

            
            this.detalleItem.tipoContratoIntegracion = precioArticulo.tipo;
            this.detalleItem.precioIntegracion = montoEnvioSac;
            this.detalleItem.totalUnitario = nuevoMontoEnvio;
            this.detalleItem.totalIntegracion =
              nuevoMontoEnvio * nuevaCantidadEnvio;
            let totalTemp = nuevoMontoEnvio * nuevaCantidadEnvio;
            this.detalleItem.cantidadIntegracion = nuevaCantidadEnvio;
            this.loadingFactores = false;

            if (this.detalleItem.total != totalTemp) {
              this.snackbar = {
                show: true,
                color: "red",
                text: "Error en cuadratura de totales, favor revisar"
              };
            }
          }
          else if (precioArticulo != undefined)
          {
              debugger;

               let factor = 1;
            if (this.detalleItem.aplicaFactor == true) {
              factor = this.detalleItem.cantidadFactor;
            } else {
              // this.detalleItem.cantidadFactor = articuloExistente.factorEmpaque;
              this.detalleItem.cantidadFactor = factor;
            }

            var cantiadadEnvioSac = parseFloat(this.detalleItem.cantidad);
            var montoEnvioSac = parseFloat(this.detalleItem.precioIntegracion);
            ///Precio Total real de la OC
            var montoTotalEnvioSac =
              parseFloat(this.detalleItem.precioIntegracion) +
              parseFloat(this.detalleItem.totalImpuestos) +
              parseFloat(this.detalleItem.totalCargos) -
              parseFloat(this.detalleItem.totalDescuentos);
            ///Empaquetado del producto
            var num = cantiadadEnvioSac / factor;
            ///Redondeo hacia abajo
            var floored_num = num - (num % 1); // floored_num will be 3
            ///Cantidad de nuevos elementos redondeados hacia abajo
            var nuevaCantidadEnvio = floored_num.toFixed();
             var nuevoMontoEnvio = ((montoTotalEnvioSac * factor) / 1).toFixed();

             
            this.detalleItem.precioIntegracion = montoEnvioSac;
            this.detalleItem.totalUnitario = nuevoMontoEnvio;
            this.detalleItem.totalIntegracion =
              nuevoMontoEnvio * nuevaCantidadEnvio;
            let totalTemp = nuevoMontoEnvio * nuevaCantidadEnvio;
            this.detalleItem.cantidadIntegracion = nuevaCantidadEnvio;
          }
          this.loadingFactores = false;
        }
      }
      else
      {
          this.detalleItem.aplicaFactor = false;
          this.detalleItem.cantidadFactor = 0;
          this.detalleItem.factorReferencia = 0;
          this.detalleItem.unidadMedidaIntegracion = "";
          this.detalleItem.codigoComboIntegracion = null;
          this.detalleItem.totalUnitario = this.detalleItem.total;
          this.detalleItem.totalIntegracion = 0;
          this.detalleItem.factorOriginal = 0;
          this.loadingFactores = false;
        
      }
    },
     openAgregarComentario()
    {
      this.tempComentario = "";
      this.selectComentario = { name: 'Informativo', icon: 'info' };
      this.dialogComentario = true;
    },
    cancelarComentario()
    {
        this.$refs.formComentario.reset();      
      this.tempComentario = "";
      this.selectComentario = { name: 'Informativo', icon: 'info' };
      this.dialogComentario = false;
    },
    async find() {
      this.loading = true;
      const response = await OrdenCompraService.findoc(this.codigo).then(r => {
        debugger;
        this.ordencompra = Object.assign(this.ordencompra, r.data);
        //info integracion
        this.integracion.codigoExterno = this.ordencompra.codigo;
        this.integracion.nroDocumentoIntegracion = this.ordencompra.nroDocumentoIntegracion;
        this.integracion.fechaVencimientoIntegracion = this.ordencompra.fechaVencimientoIntegracion;
        this.integracion.descuentoGralIntegracion = this.ordencompra.descuentoGralIntegracion;
        this.integracion.tipoDescuentoIntegracion = this.ordencompra.tipoDescuentoIntegracion;
        this.integracion.observacionesFavintegracion = this.ordencompra.observacionesFavintegracion;
        this.integracion.codigoVendedorIntegracion = this.ordencompra.codigoVendedorIntegracion;
        this.integracion.glosaPagoIntegracion = this.ordencompra.glosaPagoIntegracion;
        this.integracion.diaVencimientoIntegracion = this.ordencompra.diaVencimientoIntegracion;
        this.integracion.fechaEntregaIntegracion = this.ordencompra.fechaEntregaIntegracion;
        this.integracion.tipoVentaIntegracion = this.ordencompra.tipoVentaIntegracion;
        this.integracion.observacionesGuiaIntegracion = this.ordencompra.observacionesGuiaIntegracion;
        this.integracion.hesreferenciaIntegracion = this.ordencompra.hesreferenciaIntegracion;
        this.integracion.hesfechaIntegracion = this.ordencompra.hesfechaIntegracion;
        this.integracion.guiaDespachoIntegracion = this.ordencompra.guiaDespachoIntegracion;
        this.integracion.fechaGuiaIntegracion = this.ordencompra.fechaGuiaIntegracion;
        this.integracion.nroContratoIntegracion = this.ordencompra.nroContratoIntegracion;
        this.integracion.fechaContratoIntegracion = this.ordencompra.fechaContratoIntegracion;
        this.integracion.nroPedidoReferencia = this.ordencompra.nroPedidoReferencia;
        this.integracion.fechaPedidoReferencia = this.ordencompra.fechaPedidoReferencia;
        this.integracion.fechaPedidoIntegracion = this.ordencompra.fechaPedidoIntegracion;
        this.integracion.cuentaVentaIntegracion = this.ordencompra.cuentaVentaIntegracion;
        this.integracion.nroPedidoIntegracion = this.ordencompra.nroPedidoIntegracion;
       


        /*
        this.integracionDefault.codigoExterno = this.ordencompra.codigo;
        this.integracionDefault.nroDocumentoIntegracion = this.ordencompra.nroDocumentoIntegracion;
        this.integracionDefault.fechaVencimientoIntegracion = this.ordencompra.fechaVencimientoIntegracion;
        this.integracionDefault.descuentoGralIntegracion = this.ordencompra.descuentoGralIntegracion;
        this.integracionDefault.tipoDescuentoIntegracion = this.ordencompra.tipoDescuentoIntegracion;
        this.integracionDefault.observacionesFavintegracion = this.ordencompra.observacionesFavintegracion;
        this.integracionDefault.codigoVendedorIntegracion = this.ordencompra.codigoVendedorIntegracion;
        this.integracionDefault.glosaPagoIntegracion = this.ordencompra.glosaPagoIntegracion;
        this.integracionDefault.diaVencimientoIntegracion = this.ordencompra.diaVencimientoIntegracion;
        this.integracionDefault.fechaEntregaIntegracion = this.ordencompra.fechaEntregaIntegracion;
        this.integracionDefault.tipoVentaIntegracion = this.ordencompra.tipoVentaIntegracion;
        this.integracionDefault.observacionesGuiaIntegracion = this.ordencompra.observacionesGuiaIntegracion;
        this.integracionDefault.hesreferenciaIntegracion = this.ordencompra.hesreferenciaIntegracion;
        this.integracionDefault.hesfechaIntegracion = this.ordencompra.hesfechaIntegracion;
        this.integracionDefault.guiaDespachoIntegracion = this.ordencompra.guiaDespachoIntegracion;
        this.integracionDefault.fechaGuiaIntegracion = this.ordencompra.fechaGuiaIntegracion;
        this.integracionDefault.nroContratoIntegracion = this.ordencompra.nroContratoIntegracion;
        this.integracionDefault.fechaContratoIntegracion = this.ordencompra.fechaContratoIntegracion;
        this.integracionDefault.nroPedidoReferencia = this.ordencompra.nroPedidoReferencia;
        this.integracionDefault.fechaPedidoReferencia = this.ordencompra.fechaPedidoReferencia;
        this.integracionDefault.fechaPedidoIntegracion = this.ordencompra.fechaPedidoIntegracion;
        this.integracionDefault.cuentaVentaIntegracion = this.ordencompra.cuentaVentaIntegracion;
        this.integracionDefault.nroPedidoIntegracion = this.ordencompra.nroPedidoIntegracion;
*/
        this.detalleItems = r.data.items.listado;

        //this.loading = false;

          const comentariosResponse = OrdenCompraService.findComentarios(this.ordencompra.id)
                .then(r => {
                    debugger;
                    this.detalleComentarios = r.data                
                    this.loading = false;
                    this.cancelarComentario();
                }).catch(r => {
                  this.loading = false;
                  console.log(r.response);
                  
                });

      });
    },
    async verDetalleHistorial(oc)
    {
      this.loadingHistorial = true;
      const response = await OrdenCompraService.getHistorialOC(oc).then(r => {
                      debugger;
                      this.detalleHistorial = r.data;                                
                      this.loadingHistorial = false;
                      this.dialogHistorial = true;
                      
                  }).catch(r => {
                    this.loadingHistorial = false;
                    console.log(r.response);                    
                  });   
    },
    async exportarOC(oc) {
      this.loading = true;
      const response = await OrdenCompraService.getOcPDF(oc,this.ordencompra.codigo);
      this.loading = false;
    },
    async getItemsOCExcel(oc) {
      this.loading = true;
      const response = await OrdenCompraService.getItemsOCExcel(oc);
      this.loading = false;
    },
    async verDetalleCorrelativo(detalle) {
      this.detalleItem = Object.assign({}, detalle);
      this.detalleItem.codigoOC = this.codigo;

      this.isLoading = true;
    
      //determina si ya tiene un producto seleccionado, si es así busca su descripción, se setea en el combobox y luego setea el factor de empaque guardado, si no tiene trae el mas nuevo
      if (this.detalleItem.codigoProductoIntegracion != null) {
        const articuloExistente = await OrdenCompraService.getArticuloByCodigo(
          this.detalleItem.codigoProductoIntegracion
        ).then(r => {
          this.detalleItem.codigoComboIntegracion = r.data;
        });

        
      }

      const response = await OrdenCompraService.findProducto("").then(r => {
        this.productosBusqueda = r.data;

        this.isLoading = false;
       
      });
      this.dialogDetalleCorrelativo = true;
      if (this.detalleItem.codigoProductoIntegracion != null) {
     const calculo =  await this.setCalculateTotales();
      }
    },
    async querySelections(v) {
      // Simulated ajax query
      this.isLoading = true;
      const response = await OrdenCompraService.findProducto(v).then(r => {
        this.productosBusqueda = r.data;

        this.isLoading = false;
      });
    }
  },
  computed: {
    dateFormatedBusquedaInicio() {
      if (!this.integracion.fechaVencimientoIntegracion) return null;
      return moment(this.integracion.fechaVencimientoIntegracion).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedfechaEntregaIntegracion() {
      if (!this.integracion.fechaEntregaIntegracion) return null;
      return moment(this.integracion.fechaEntregaIntegracion).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedfechaHESIntegracion() {
      if (!this.integracion.hesfechaIntegracion) return null;
      return moment(this.integracion.hesfechaIntegracion).format("DD-MM-YYYY");
    },
    dateFormatedfechaGuiaIntegracion() {
      if (!this.integracion.fechaGuiaIntegracion) return null;
      return moment(this.integracion.fechaGuiaIntegracion).format("DD-MM-YYYY");
    },
    dateFormatedfechaContratoIntegracion() {
      if (!this.integracion.fechaContratoIntegracion) return null;
      return moment(this.integracion.fechaContratoIntegracion).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedfechaPedidoReferencia() {
      if (!this.integracion.fechaPedidoReferencia) return null;
      return moment(this.integracion.fechaPedidoReferencia).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedfechaPedidoIntegracion() {
      if (!this.integracion.fechaPedidoIntegracion) return null;
      return moment(this.integracion.fechaPedidoIntegracion).format(
        "DD-MM-YYYY"
      );
    },
    AplicaFactor() {
      return this.detalleItem.aplicaFactor === undefined ||
        this.detalleItem.aplicaFactor === "" ||
        this.detalleItem.aplicaFactor == false
        ? true
        : false;
    }
  },
  watch: {
    searchProductos(val) {
      // Items have already been loaded
      debugger;
      //if (this.detalleItem.codigoProductoIntegracion.length > 0) return
      val && val !== this.select && this.querySelections(val);
    }
  },
  beforeRouteUpdate(to, from, next) {
    debugger;
     
    next();
  },
  mounted() {
   
     debugger;
     
    if(this.$route.query.codigo == undefined || this.$route.query.codigo == null)
    {
      this.loading = false;
      this.$router.push("/ordencompraingreso");
    }
    else
    {
         this.codigo = this.$route.query.codigo; //this.$route.query.codigo;
          this.find();
    }
    
  },
  created() {
    window.getApp = this;
     if(this.$route.query.codigo == undefined || this.$route.query.codigo == null)
    {
      this.loading = false;
     this.$router.push("/ordencompraingreso");
    }   
     
    
  }
};
</script>
